import { useEffect, useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import { Button } from "antd";
import { LinkOutlined } from "@ant-design/icons";

const useQrSize = () => {
  const getSize = () =>
    typeof window !== "undefined" && window.innerWidth < 768 ? 90 : 130;
  const [size, setSize] = useState(getSize);

  useEffect(() => {
    const onResize = () => setSize(getSize());
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return size;
};

const ApprovedBarcode = ({ approvalKey }) => {
  const qrSize = useQrSize();

  if (!approvalKey) return null;

  const url = `${window.location.origin}/wf/approved/${approvalKey}`;

  return (
    <div className="approved-barcode-section text-center">
      <label style={{ fontSize: 15, fontWeight: "bold" }}>
        Approval Barcode
      </label>
      <div className="mt-3 text-center">
        <QRCodeSVG
          size={qrSize}
          style={{
            border: "1px solid #d9d9d9",
            borderRadius: 4,
            padding: 10,
          }}
          value={url}
        />
      </div>
      <div className="mt-2 text-center">
        <Button
          type="link"
          size="small"
          icon={<LinkOutlined />}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          style={{ fontSize: 12 }}
        >
          Buka verifikasi
        </Button>
      </div>
    </div>
  );
};

export default ApprovedBarcode;
